export const environment = {
  production: true,
  apiURL : 'https://backend.dev.retterseismo.com/',
  leskey : 'aRe93f230eljdklArk0o4Se',
}